import SectionHeading from "@/pages/home/components/SectionHeading";
import { skills } from "@/mocks/content";

export default function SkillsSection() {
  return (
    <section id="skills" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-6 md:px-8">
        <SectionHeading
          eyebrow="恋爱技巧"
          title="把喜欢，变成可以练习的能力"
          desc="恋爱不只是运气，也是一些具体的做法：怎么心动、怎么沟通、怎么表达、怎么建立安全感。下面六条技巧，覆盖一段关系从开始到稳定的关键动作。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {skills.map((skill, index) => (
            <article
              key={skill.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-200 md:p-6"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 font-label text-sm text-primary-700">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-950 md:text-lg">{skill.title}</h3>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700">{skill.desc}</p>
              <ul className="mt-4 space-y-2 border-t border-background-200 pt-4">
                {skill.points.map((point) => (
                  <li key={point} className="flex items-start gap-2 text-xs text-foreground-600 md:text-sm">
                    <i className="ri-checkbox-circle-fill mt-0.5 text-secondary-500"></i>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}